var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2944_4473",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 183,
    width: 423,
    height: 288
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6641 183.333H463.827V470.767H41.6641V183.333Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2944_4473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.7422 470.837V348.236C41.7422 339.399 48.9056 332.236 57.7422 332.236H141.705C150.542 332.236 157.705 339.399 157.705 348.236V470.837H41.7422ZM308.967 470.837V288.6C308.967 279.764 301.803 272.6 292.967 272.6H210.68C201.843 272.6 194.68 279.763 194.68 288.6V470.837H308.967ZM463.588 470.837V199.558C463.588 190.721 456.425 183.558 447.588 183.558H363.615C354.779 183.558 347.615 190.721 347.615 199.558V470.837H463.588Z",
    fill: "#f0fff1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2944_4473",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 33,
    width: 391,
    height: 265
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4141 36.75H427.713V293.682H45.4141V36.75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 7.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2944_4473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.552 162.47L337.923 85.7246C344.138 79.5608 344.046 69.4992 337.918 63.355C333.037 58.4603 335.854 50.1556 342.486 49.2276L416.449 38.8778C421.819 38.1264 426.442 42.6717 425.781 48.0539L416.539 123.302C415.7 130.129 407.366 132.992 402.509 128.122L399.021 124.624C392.851 118.437 382.823 118.455 376.675 124.666L264.012 238.484L263.999 238.498L255.831 246.666C252.609 249.888 247.386 249.888 244.164 246.666L236.008 238.511L235.982 238.484L200.764 202.567C194.625 196.307 184.556 196.264 178.366 202.473L94.5566 286.515C91.526 289.554 86.6716 289.762 83.3923 286.993L54.051 262.218C50.3625 259.103 50.1245 253.501 53.5357 250.085L183.819 119.612C187.04 116.387 192.266 116.385 195.49 119.607L238.325 162.426C244.459 168.558 254.394 168.577 260.552 162.47Z",
    fill: "#f0fff1",
    stroke: "#f0fff1",
    strokeWidth: 7.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.de1a10a7148b9e88736fe40444bd4fb2.svg";
export { ForwardRef as ReactComponent };